<template>
  <z-form-group :class="group_classes">
    <div :class="label_classes" v-html="$t('pbx.worksheet.action.field.name.title')"></div>
    <z-form-input :class="input_classes">
      <i-input
        :value="value"
        :placeholder="$t(`pbx.worksheet.action.type.${box_type}`)"
        @input="$emit('input', $event)"
      />
    </z-form-input>
  </z-form-group>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        default: ''
      },
      box_type: {
        type: String,
        default: ''
      },
      group_classes: {
        type: Array,
        default: () => ['row']
      },

      label_classes: {
        type: Array,
        default: () => ['col-4', 'text-right']
      },

      input_classes: {
        type: Array,
        default: () => ['col-8']
      }
    }
  };
</script>
